import { useEffect, useState } from 'react';
import { api } from '../api';

const MODULE_LABELS: Record<string, string> = {
  auth: '认证', departments: '部门', users: '用户', roles: '角色', permissions: '权限',
  finance: '财务', products: '产品', sales: '销售', inventory: '库存',
  production: '生产', customer: '客户', attendance: '考勤', system: '系统',
};
const ACTION_LABELS: Record<string, string> = {
  create: '新建', edit: '编辑', delete: '删除', view: '查看', login: '登录',
  logout: '登出', approve: '审批', complete: '完成', 'reset-pwd': '重置密码',
  backup: '备份', seed: '种子数据',
};

export default function Logs() {
  const [logs, setLogs] = useState<any[]>([]);
  const [filterModule, setFilterModule] = useState('');
  const [filterAction, setFilterAction] = useState('');

  const load = () => {
    const params: string[] = [];
    if (filterModule) params.push(`module=${filterModule}`);
    if (filterAction) params.push(`action=${filterAction}`);
    api('/system/logs' + (params.length ? '?' + params.join('&') : '')).then(setLogs).catch(() => {});
  };

  useEffect(load, [filterModule, filterAction]);

  // 去重模块和操作
  const modules = [...new Set(logs.map((l) => l.module))];
  const actions = [...new Set(logs.map((l) => l.action))];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">操作日志</h2>
          <p className="text-sm text-slate-500 mt-1">系统审计追踪，所有关键操作均有记录</p>
        </div>
        <a href="/api/system/backup" className="text-sm text-brand-600 hover:underline border border-brand-200 rounded-lg px-3 py-2">
          📥 下载数据库备份
        </a>
      </div>

      {/* 过滤器 */}
      <div className="flex gap-3 bg-white rounded-xl shadow p-4">
        <select className="border rounded-lg px-3 py-2 text-sm" value={filterModule} onChange={(e) => setFilterModule(e.target.value)}>
          <option value="">全部模块</option>
          {modules.map((m) => <option key={m} value={m}>{MODULE_LABELS[m] || m}</option>)}
        </select>
        <select className="border rounded-lg px-3 py-2 text-sm" value={filterAction} onChange={(e) => setFilterAction(e.target.value)}>
          <option value="">全部操作</option>
          {actions.map((a) => <option key={a} value={a}>{ACTION_LABELS[a] || a}</option>)}
        </select>
        <div className="text-sm text-slate-500 self-center ml-auto">共 {logs.length} 条记录</div>
      </div>

      {/* 日志表格 */}
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 text-slate-500 text-left">
              <th className="p-3">时间</th><th>操作人</th><th>模块</th><th>操作</th><th>详情</th><th>IP</th>
            </tr>
          </thead>
          <tbody>
            {logs.slice(0, 200).map((l) => (
              <tr key={l.id} className="border-t hover:bg-slate-50">
                <td className="p-3 text-xs text-slate-500 whitespace-nowrap">{(l.created_at || '').replace('T', ' ')}</td>
                <td className="p-3 font-medium">{l.username || '—'}</td>
                <td className="p-3">
                  <span className="text-xs px-2 py-0.5 bg-indigo-50 text-indigo-700 rounded">{MODULE_LABELS[l.module] || l.module}</span>
                </td>
                <td className="p-3">
                  <span className={`text-xs px-2 py-0.5 rounded ${
                    ['create','approve','complete'].includes(l.action) ? 'bg-green-50 text-green-700' :
                    ['delete'].includes(l.action) ? 'bg-red-50 text-red-700' :
                    ['edit'].includes(l.action) ? 'bg-yellow-50 text-yellow-700' :
                    'bg-slate-100 text-slate-600'
                  }`}>{ACTION_LABELS[l.action] || l.action}</span>
                </td>
                <td className="p-3 text-xs text-slate-600 max-w-[300px] truncate" title={l.detail}>{l.detail || '—'}</td>
                <td className="p-3 text-xs text-slate-400 font-mono">{l.ip || '—'}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-slate-400">暂无日志记录</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
